export default __webpack_public_path__ + "static/media/step-2-of-4.0e292d16.gif";